document.addEventListener('DOMContentLoaded', function () {

  const selectors = document.querySelectorAll('[data-worldwide-selector]');

  selectors.forEach(function (selector) {

    /* =====================================================
       COUNTRY / SHOPIFY MARKET
       ===================================================== */

    const countryForm = selector.querySelector('#WorldwideCountryForm');
    const countryInput = selector.querySelector('[data-ww-country-input]');

    selector.querySelectorAll('[data-country-code]').forEach(function (button) {

      button.addEventListener('click', function () {

        const countryCode = button.getAttribute('data-country-code');

        if (!countryForm || !countryInput || !countryCode) {
          return;
        }

        countryInput.value = countryCode;
        countryForm.submit();

      });

    });


    /* =====================================================
       LANGUAGE
       ===================================================== */

    const languageForm = selector.querySelector('#WorldwideLanguageForm');
    const languageInput = selector.querySelector('[data-ww-language-input]');

    selector.querySelectorAll('[data-language-code]').forEach(function (button) {

      button.addEventListener('click', function () {

        const languageCode = button.getAttribute('data-language-code');

        if (!languageForm || !languageInput || !languageCode) {
          return;
        }

        languageInput.value = languageCode;
        languageForm.submit();

      });

    });


    /* =====================================================
       CLOSE BUTTON
       ===================================================== */

    const closeButton = selector.querySelector('[data-ww-close]');

    if (closeButton) {
      closeButton.addEventListener('click', function (event) {
        event.preventDefault();
        selector.removeAttribute('open');
      });
    }

  });


  /* =======================================================
     CLICK OUTSIDE = CLOSE
     ======================================================= */

  document.addEventListener('click', function (event) {

    document
      .querySelectorAll('[data-worldwide-selector][open]')
      .forEach(function (selector) {

        if (!selector.contains(event.target)) {
          selector.removeAttribute('open');
        }

      });

  });


  /* =======================================================
     ESCAPE = CLOSE
     ======================================================= */

  document.addEventListener('keydown', function (event) {

    if (event.key !== 'Escape') {
      return;
    }

    document
      .querySelectorAll('[data-worldwide-selector][open]')
      .forEach(function (selector) {
        selector.removeAttribute('open');
      });

  });

});